import JQuery from 'jquery'

import Vue from 'vue'
import Notifications from 'vue-notification'
import VeeValidate, { Validator } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr'
import vueMoment from 'vue-moment'
import moment from 'moment'
import VueAnalytics from 'vue-analytics'
import VueMatomo from 'vue-matomo'

import App from './App'
import router from './router'
import store from './store'
import inputUI from './common/directives/inputUI'
import radioBox from './common/components/Form/RadioBox'
import baseModal from './common/components/baseModal'
import { VueRobot } from './common/services/iRobot'
import { VueCookie } from './common/services/Cookie'
import ImageDetect from './common/directives/ImageDetect'
import agTable from './common/components/ag-table'
import 'es6-promise/auto'

// Style for Ag-Grid
import '../node_modules/ag-grid/dist/styles/ag-grid.css'
import '../node_modules/ag-grid/dist/styles/ag-theme-balham.css'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import VueSweetalert2 from 'vue-sweetalert2'

window.$ = JQuery
window.jQuery = JQuery

require('moment/locale/fr')

Sentry.init({
	dsn: 'https://a389d9a9258e43b9bbd7558e12717f64@sentry.io/1847594',
	environment: process.env.NODE_ENV,
	integrations: [new Integrations.Vue({Vue, attachProps: true})]
})

Vue.use(Notifications)
Validator.localize('fr', fr)
Vue.use(VeeValidate)
Vue.use(inputUI)
Vue.use(vueMoment, { moment })
Vue.use(VueRobot)
Vue.use(VueCookie)
Vue.component('radio-box', radioBox)
Vue.component('base-modal', baseModal)
Vue.component('ag-table', agTable)
Vue.use(ImageDetect)
Vue.use(VueAnalytics, {
	id: 'UA-109825003-2',
	autoTracking: {
		screenview: true
	}
})
Vue.use(VueMatomo, {
	host: 'https://matomo.kevintessier.fr/',
	siteId: 3,
	router: router,
	enableLinkTracking: true,
	trackInitialView: true,
	trackerFileName: 'matomo'
})
Vue.use(VueSweetalert2)

require('./common/services/ExtendRules')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App,
		radioBox
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js